import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const base = `${API}/api/referral-portal`;
const opts = { withCredentials: true };

export const referralApprovalApi = {
  getConfig: () => axios.get(`${base}/approval-config`, opts).then((r) => r.data),
  saveConfig: (body) => axios.put(`${base}/approval-config`, body, opts).then((r) => r.data),
  options: () => axios.get(`${base}/approval-options`, opts).then((r) => r.data),
  inbox: () => axios.get(`${base}/approval-inbox`, opts).then((r) => r.data),
  inboxOne: (id) => axios.get(`${base}/approval-inbox/${id}`, opts).then((r) => r.data),
  decide: (id, body) => axios.post(`${base}/approval-inbox/${id}/decide`, body, opts).then((r) => r.data),
};
